<template>
  <div>
    <v-row>
      <v-col>
        <v-combobox
          clearable
          dense
          :items="searchUnits"
          item-text="uom"
          item-value="uom"
          chips
          deletable-chips
          clear-icon="mdi-close-circle"
          label="Unit of Measure"
          v-model="selectedUnit"
          hide-selected
          :search-input.sync="searchUom"
          @change="searchUom = ''"
          v-bind:value="value"
          v-on:input="$emit('input', $event ? $event.uom : '')"
          ref="combobox"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <p>
                    No Unit of Measure matching "
                    <strong>{{ searchUom }}</strong>
                    ". Press
                    <kbd>enter</kbd>
                    to create it.
                  </p>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:selection="{ attr, on, item, selected }">
            <v-chip
              v-bind="attr"
              :input-value="selected"
              :color="getItemColor(item)"
              class="white--text"
              v-on="on"
              close
              @click:close="selectedUnit = null"
            >
              <span v-text="item.uom"></span>
            </v-chip>
          </template>
        </v-combobox>
      </v-col>
    </v-row>
    <v-row v-if="showNewUnitFields" class="align-center">
      <v-col>
        <v-text-field
          type="text"
          label="Long name"
          v-model="selectedUnit.longName"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          type="text"
          label="Description"
          v-model="selectedUnit.description"
        ></v-text-field>
      </v-col>
      <v-col cols="2" class="d-flex justify-end">
        <v-btn
          class=""
          type="button"
          small
          color="primary"
          @click.stop="addNewUom"
        >
          Add
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'AddUnits',
  props: ['value'],
  data() {
    return {
      selectedUnit: this.value,
      searchUom: '',
      showUnitFields: false,
    };
  },
  computed: {
    ...mapGetters('allUoms', { units: 'list' }, { root: true }),
    searchUnits() {
      return [{ header: 'Select a unit or create one' }].concat(this.units);
    },
    showNewUnitFields() {
      return this.showUnitFields && this.selectedUnit && this.selectedUnit.new;
    },
  },
  methods: {
    getItemColor(item) {
      return item.new ? '#039BE5' : '#78909C';
    },
    addNewUom() {
      // Add the unit of measure to the node
      // const obj = { uom: this.selectedUnit.uom, description: this.selectedUnit.description };
      // obj['long-name'] = this.selectedUnit.longName;
      // const payload = { name: obj.uom, ...obj };
      // const result = await this.$store.dispatch('postNewUom/createUom', payload);
      // this.$store.dispatch('addNotification', {
      //   type: result ? 'success' : 'errorMessage',
      //   message: `${result ? 'Added' : 'Could not add'} new unit of measure ${this.selectedUnit.uom} `,
      // });
      // if (result) {
      //   // Update the store with the new uom
      //   this.$store.commit('allUoms/updateUoms', result);
      //   this.showUnitFields = false;
      // }
      const obj = {
        uom: this.selectedUnit.uom,
        description: this.selectedUnit.description,
        new: this.selectedUnit.new,
      };
      obj['long-name'] = this.selectedUnit.longName;
      this.$emit('input', obj);
      this.showUnitFields = false;
    },
  },
  watch: {
    selectedUnit(val, prev) {
      setTimeout(() => {
        this.$refs.combobox.isMenuActive = false;
      }, 50);

      if (val === prev) return;
      if (val === null) {
        this.$emit('input', '');
      }
      let v = this.selectedUnit;

      if (v && typeof v === 'string') {
        this.showUnitFields = true;
        // Convert new unit into an object
        v = {
          uom: v,
          longName: v,
          description: '',
          new: true,
        };
        this.selectedUnit = v;
      } else {
        if (v && !v.new) {
          this.showUnitFields = false;
        }
      }
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.close-button {
  position: absolute;
  right: 0px;
  cursor: pointer;
  z-index: 200;
}
.full-width {
  width: 100%;
}
</style>
